import {Entity} from "../domain/entities/entity";
import {Issue} from "../domain/entities/issue.entity";
import {Project} from "../domain/entities/project.entity";
import {Employee} from "../domain/entities/employee.entity";
import {IssueStatus} from "../domain/entities/issue-status.entity";
import {IssueType} from "../domain/entities/issue-type.entity";
import {Keyword} from "../domain/entities/keyword.entity";
import {ProjectType} from "../domain/entities/project-type.entity";
import {EmployeeToIssueAssignment} from "../domain/entities/employee-to-issue-assignment.entity";

/**
 * Gets a human-readable display name for an entity, as notifications show it.
 *
 * Projects, project types, statuses, types and keywords have no `name`; their display field is
 * whatever their own toString() returns (title, key or description). An empty one falls back to
 * the type and the start of the uid.
 *
 * @param entity The entity to get display name for
 * @returns Display name for the entity
 */
export function entityDisplayName(entity: Entity): string {
    // Entity-specific display name logic
    if (entity instanceof Issue) {
        return entity.title || `Task ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof Project) {
        return entity.toString() || `Projekt ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof Employee) {
        return entity.name || `Mitarbeiter ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof IssueStatus) {
        return entity.toString() || `Status ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof IssueType) {
        return entity.toString() || `Typ ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof Keyword) {
        return entity.toString() || `Keyword ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof ProjectType) {
        return entity.toString() || `Projekttyp ${entity.uid.substring(0, 8)}`;
    }
    
    if (entity instanceof EmployeeToIssueAssignment) {
        return `Zuweisung ${entity.uid.substring(0, 8)}`;
    }
    
    // Fallback for unknown entity types
    return `${entity.constructor.name} ${entity.uid.substring(0, 8)}`;
}
